import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

import { Helmet } from 'react-helmet'

import { getFullFundInfo } from '../selectors/funds.js'
import { getFund } from '../store/reducers/funds/list.js'
import { getLots, getFixedPriceLots, getPersons, getFixedpriceLotsPersons, clear } from '../store/reducers/funds/fund.js'

import MainContainer from './Main'
import SingleList from './LotList/singleList'
import Sidebar from './../components/Fund/Sidebar'
import BidHistory from '../components/Lot/BidHistory'
import DonationStats from '../components/Fund/DonationStats'

import {sendViewCard} from './../helpers/tagManager'

const FundPage = ({ info, lots = [], fixedpricelots = [], persons = [], fixedpricelotspersons = [], intl, meta }) => !info ? null : (
  <MainContainer
    sidebarNoBody
    Sidebar={
      <Sidebar data={info} />
    }
  >
  <Helmet>
    <title>{meta.name}</title>
    <meta name='description' content={meta.description} />
    <meta property='og:title' content={meta.name} />
    <meta property='og:image' content={meta.image} />
    <meta property='og:url' content={window.location.href} />
    <meta property='og:description' content={meta.description} />
  </Helmet>
    <DonationStats info={info.lotsStats} />
    <div className='Main__description Text' dangerouslySetInnerHTML={{ __html: info.description }} />
    <SingleList items={lots} title={intl.formatMessage({id: 'fund.active_auctions'})} withPadding={persons.length > 0} listName={'Активные аукционы фонда'} />
	  <SingleList items={fixedpricelots} title={intl.formatMessage({id: 'fund.active_auctions'})} withPadding={fixedpricelotspersons.length > 0} listName={'Активные аукционы фонда (с фикс стоимостью)'} />
    {persons.length > 0 && (<BidHistory show={true} items={persons} title={intl.formatMessage({id: 'fund.participants_supported'})} />)}
	  {fixedpricelotspersons.length > 0 && (<BidHistory show={true} items={fixedpricelotspersons} title={intl.formatMessage({id: 'fund.fixedpricelots_participants_supported'})} />)}
  </MainContainer>
)

const mapStateToProps = () => {
  const getInfo = getFullFundInfo()
  return (state, props) => ({
    info: getInfo(state, props),
    ...state.funds.fund
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({ getFund, getLots, getFixedPriceLots, getPersons, getFixedpriceLotsPersons, clear }, dispatch)

const mergeProps = (state, dispatch, props) => {
  const getDetails = async (id) => {
    if (!id) return
    await Promise.all([
      dispatch.getLots(id),
	    dispatch.getFixedPriceLots(id),
      dispatch.getPersons(id),
	    dispatch.getFixedpriceLotsPersons(id)
    ])
  }

  const getInfo = async (id) => {
    id = id || props.id
    if (!id) return

    if (props.info) {
      await getDetails(id)
    } else {
      // Fire fund info and details in parallel instead of sequentially
      const [code] = await Promise.all([
        dispatch.getFund(id),
        getDetails(id)
      ])
      if (code !== 200) props.on404()
    }
  }

  return { ...props, ...state, getInfo }
}

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    async componentWillMount () {
      await this.props.getInfo()
    },
    componentWillReceiveProps (np) {
      if (np.id !== this.props.id) this.props.getInfo(np.id)
      if (np.lots && np.lots.length > 0 && np.lots !== this.props.lots) sendViewCard(np.lots, 'Активные аукционы фонда')
      if (np.fixedpricelots && np.fixedpricelots.length > 0 && np.fixedpricelots !== this.props.fixedpricelots) sendViewCard(np.fixedpricelots, 'Активные аукционы фонда (с фикс стоимостью)')
    }
  })
)(FundPage))



// WEBPACK FOOTER //
// ./src/containers/Fund.jsx